import { useState } from "react";
import { t } from "../i18n/en";

/**
 * The first-login offer to save a home point (PLAN D4).
 *
 * Dismissible, and dismissing it is a legitimate choice rather than a deferral — the account
 * then runs live-only: full alerting while the app is open, none from a cold start. That
 * consequence is stated here rather than discovered later, and the Alerts page repeats it on
 * any rule it affects.
 */
export default function HomePrompt({
  onUseLocation,
  onDismiss,
}: {
  onUseLocation: () => Promise<void>;
  onDismiss: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  return (
    <div className="prompt">
      <h2>{t.homePrompt.title}</h2>
      <p>{t.homePrompt.body}</p>
      <p className="hint">{t.homePrompt.consequence}</p>
      {error && <p className="error">{error}</p>}
      <div className="row">
        <button
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            setError("");
            try {
              await onUseLocation();
            } catch (err) {
              setError(err instanceof Error ? err.message : t.homePrompt.failed);
              setBusy(false);
            }
          }}
        >
          {busy ? t.settings.locating : t.homePrompt.use}
        </button>
        <button className="secondary" onClick={onDismiss} disabled={busy}>
          {t.homePrompt.dismiss}
        </button>
      </div>
    </div>
  );
}
